import {
  BREAKPOINT_DESKTOP_XL,
  BREAKPOINT_MUI_NAV_SHRINK_8_PX,
  NAV_HEIGHT_MOBILE_PX,
  NAV_HEIGHT_PX,
  TILE_WIDTH_PX_SM,
} from "../../../constants/constants";
import styled, { css } from "styled-components/macro";
import { TILES_CARD } from "pages/useTileSize";
import {
  getDashboardCardsResponsiveStyles,
  getGroupMetricsResponsiveStyles,
  getGroupTilesResponsiveStyles,
  getMachineBreakdownChartResponsiveStyles,
  getOverallBarstackResponsiveStyles,
  getPnlPopupChartResponsiveStyles,
  getProcessTilesResponsiveStyles,
  getRangeSelectorResponsiveStyles,
  getTilesTimelineTabsResponsiveStyles,
  getTimelineChartResponsiveStyles,
  getTrendChartResponsiveStyles,
} from "components/Dashboard/styles/getDashboardCardsResponsiveStyles";
import { cardBorder } from "constants/colors";

export const DashboardPagesContentStyles = styled.div<{
  $isHubletPage?: boolean;
  $scale?: number;
  $tileWidthConfig?: number;
}>`
  min-height: calc(100vh - ${NAV_HEIGHT_MOBILE_PX}px);
  @media (min-width: ${BREAKPOINT_MUI_NAV_SHRINK_8_PX}px) {
    min-height: calc(100vh - ${NAV_HEIGHT_PX}px);
  }
  .${TILES_CARD} {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin-bottom: 1em;
    padding-top: 108px;
    margin-top: 0;
  }
  .belowDividerContent {
    padding-bottom: 1em;
  }
  [class*="CardWithControls__CardStyles"] {
    margin-top: 0px;
    margin-bottom: 8px;
  }

  @media screen and (min-width: ${BREAKPOINT_DESKTOP_XL}px) {
    /* adding many &s here to manually increase this block's specificity,
    so that it overrides other CSS in this app without having to modify other files or to use !important */
    &&&&&&&&&&&&&&&&&&&&&&&&& {
      ${props =>
        !props.$scale || props.$isHubletPage
          ? ""
          : css`
              ${getTilesTimelineTabsResponsiveStyles(props.$scale)}
              ${getDashboardCardsResponsiveStyles(props.$scale)}
              ${getRangeSelectorResponsiveStyles(props.$scale)}
              ${getGroupMetricsResponsiveStyles(props.$scale)}
              ${getOverallBarstackResponsiveStyles(props.$scale)}
              ${getTrendChartResponsiveStyles(props.$scale)}
              ${getPnlPopupChartResponsiveStyles(props.$scale * 2)}
              /* increase trend chart height on Timeline page, outside of getTrendChartResponsiveStyles
              (whereas Hublet page serves as more of a permanent display, so there we keep it short to preserve vertical space) */
              .Card_TrendChart {
                .cardContent {
                  height: ${props.$scale * 400}px;
                }
              }
              ${getTimelineChartResponsiveStyles(props.$scale, true)}
              ${getProcessTilesResponsiveStyles(props.$scale)}
              ${getGroupTilesResponsiveStyles(
                props.$scale,
                (props.$tileWidthConfig ?? 1) * TILE_WIDTH_PX_SM
              )}
              ${getMachineBreakdownChartResponsiveStyles(props.$scale)}

              [data-component-name="Toggle Tiles Full Day"] {
                .btnToggleFullDay {
                  font-size: ${props.$scale * 14}px;
                  &:last-child {
                    margin-left: ${props.$scale * 10}px;
                  }
                }
              }
            `}
    }
  }
  .resize-handle {
    right: -11px !important;
    width: 12px !important;
    &:hover {
      background: rgba(0, 0, 0, 0.05);
      &:after {
        content: "";
        position: absolute;
        right: 3px;
        height: 64px;
        top: 50%;
        background: white;
        border-radius: 999px;
        border: 1px solid ${cardBorder};
        width: 3px;
      }
    }
  }
`;
